import { ServiceAction } from "@repo/common"
import { H3 } from "@repo/ui/components/ui/typography"
import { cn } from "@repo/ui/lib/utils"
import {
  SelectableCardDescription,
  SelectableCardTitle,
} from "@repo/ui/tanstack-form"
import * as React from "react"
import { useTranslations } from "use-intl"
import { serviceActionMapper } from "../../lib/service-action-mapper"
import { ImageDisplay } from "./image-display"

interface ManualActionProps {
  variant: "manual-action"
  title: string
  className?: string
}

interface PartActionProps {
  variant: "part-action"
  partName: string
  partAction: ServiceAction
  partImage: string
  className?: string
}

type ProductChoiceHeaderProps = ManualActionProps | PartActionProps

const ProductChoiceHeader = React.forwardRef<
  HTMLDivElement,
  ProductChoiceHeaderProps
>(({ className, ...props }, ref) => {
  const t = useTranslations()
  if (props.variant === "manual-action") {
    return (
      <div ref={ref} className={cn("mb-3", className)}>
        <H3 size="lg" weight="medium">
          {props.title}
        </H3>
      </div>
    )
  }

  const { partName, partAction, partImage } = props
  const label = t(serviceActionMapper(partAction).labelKey)

  return (
    <div
      ref={ref}
      className={cn("mb-2 flex items-center justify-between", className)}
    >
      <div className="space-y-1">
        <SelectableCardTitle>{label}</SelectableCardTitle>
        <SelectableCardDescription>{partName}</SelectableCardDescription>
      </div>

      <div className="flex-shrink-0">
        <ImageDisplay image={partImage} alt={partName} />
      </div>
    </div>
  )
})

ProductChoiceHeader.displayName = "ProductChoiceHeader"

export { ProductChoiceHeader, type ProductChoiceHeaderProps }
